import { motion } from 'framer-motion'
import { useInView } from './useInView'
import { ArrowUpRight } from 'lucide-react'

export default function CTA() {
  const { ref, isInView } = useInView()

  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-radial-top" />

      <div ref={ref} className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-6">
            Gotowy na{' '}
            <span className="text-gradient-warm">wspolprace?</span>
          </h2>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto leading-relaxed mb-12">
            Jesli prowadzisz obiekt sportowy, szukasz partnera technologicznego
            lub chcesz sie dowiedziec wiecej o Spotto - odezwij sie do nas.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:hello@solidlabs.site"
              className="group inline-flex items-center gap-2 px-8 py-4 bg-brand-600 hover:bg-brand-500 text-white font-semibold rounded-2xl transition-all hover:shadow-xl hover:shadow-brand-600/25 hover:-translate-y-0.5"
            >
              Napisz do nas
              <ArrowUpRight
                size={18}
                className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
            <a
              href="https://spotto.pl"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/[0.04] hover:bg-white/[0.08] text-zinc-300 hover:text-white border border-white/[0.08] hover:border-white/[0.12] font-semibold rounded-2xl transition-all"
            >
              Zobacz Spotto
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
